import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowDown } from 'react-icons/io';
import { HiMenuAlt3, HiX } from 'react-icons/hi';

const Header = ({ onMenuToggle }) => {
    const [solutionsDropdown, setSolutionsDropdown] = useState(false);
    // const [servicesDropdown, setServicesDropdown] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    // const [isVisible, setIsVisible] = useState(true);
    // const [lastScrollY, setLastScrollY] = useState(0);

    // Function to toggle the mobile menu's open/close state
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        setSolutionsDropdown(false);
        // setServicesDropdown(false);
        if (onMenuToggle) onMenuToggle(!isMenuOpen); // Notify parent (Index.jsx)
    };

    // Notify parent if menu is closed by other means
    useEffect(() => {
        if (onMenuToggle) onMenuToggle(isMenuOpen);
    }, [isMenuOpen, onMenuToggle]);

    // Listen for scroll to change header background
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            
            // Change background when scrolled
            if (currentScrollY > 10) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div
            className={`Header font-nixie-one text-black fixed top-0 w-full bg-white`}
            style={{
                zIndex: 40,
                background: scrolled
                    ? 'white' // dark background when scrolled
                    : 'white',
                transition: 'background 0.3s, box-shadow 0.2s',
                boxShadow: scrolled ? '0 2px 16px 0 rgba(80,0,120,0.10)' : 'none'
            }}
        >
            <div className='headerContainer w-full h-16 px-4 md:px-10 lg:px-10 lg:py-2 mx-auto hidden md:flex md:flex-row md:items-center md:justify-center md:gap-0 relative'>
                {/* Desktop headerTitle - hidden on mobile */}
                <div className='headerTitle flex-1 flex justify-center items-center pt-2'>
                    <Link to={'/'} className='flex flex-row gap-1 items-start'>
                        <img src="../assets/mainlogotransparentbg.png" alt="VRify Logo" className='h-14 w-full object-cover' />
                        {/* <p className='capitalize text-base cursor-pointer whitespace-nowrap'>VRify technologies</p> */}
                    </Link>
                </div>

                {/* Desktop headerTabs - hidden on mobile */}
                <div className='headerTabs flex-1 flex justify-center'>
                    <div className='flex flex-row justify-center items-center'>
                        <ul className='flex flex-row gap-8 items-center'>
                            <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'><a href={'/'}>home</a></li>
                            {/* <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'><a href={'/request-quote'}>request quote</a></li> */}
                            {/* <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'><a href={'/vr-engagements'}>VR engagements</a></li> */}
                            <li
                                onMouseEnter={() => setSolutionsDropdown(true)}
                                onMouseLeave={() => setSolutionsDropdown(false)}
                                className='relative capitalize text-sm font-semibold tracking-tight hover:text-blue-400'
                            >
                                <p className='flex items-center gap-1 cursor-pointer whitespace-nowrap'>
                                    <span>products</span>
                                    <IoIosArrowDown />
                                </p>
                                {solutionsDropdown && (
                                    <ul className='absolute top-full left-0 mt-0 bg-white border-t-4 border-blue-400 shadow-lg rounded-md p-2 w-72 z-20 text-black font-semibold'>
                                        <a href='/business-loans'>
                                            <li className='flex flex-row items-center gap-1 text-xs p-1 rounded-md capitalize hover:white hover:bg-blue-400 hover:text-black'>
                                                business loans - Rapid Cash
                                            </li>
                                        </a>
                                        <a href='/sme-loans'>
                                            <li className='flex flex-row items-center gap-1 text-xs p-1 rounded-md capitalize hover:white hover:bg-blue-400 hover:text-black'>
                                                SME Loans - Speedy Sika
                                            </li>
                                        </a>
                                        <a href='/salary-loans'>
                                            <li className='flex flex-row items-center gap-1 text-xs p-1 rounded-md capitalize hover:white hover:bg-blue-400 hover:text-black'>
                                                salary loans - Instant Advance
                                            </li>
                                        </a>
                                    </ul>
                                )}
                            </li>
                            {/* <li
                                onMouseEnter={() => setServicesDropdown(true)}
                                onMouseLeave={() => setServicesDropdown(false)}
                                className='relative capitalize text-sm font-semibold tracking-tight hover:text-blue-400'
                            >
                                <p className='flex items-center gap-1 cursor-pointer'>
                                    <span>services</span>
                                    <IoIosArrowDown />
                                </p>
                                {servicesDropdown && (
                                    <ul className='absolute top-full left-0 mt-0 bg-white border-t-4 border-blue-400 shadow-lg rounded-md p-2 w-72 z-20 text-black font-semibold'>
                                        <Link to={'https://vrifyafrica.onrender.com/virtual-tour'} target='_blank' rel='noopener noreferrer'>
                                            <li className='flex flex-row items-center gap-1 text-sm p-1 rounded-md capitalize hover:white hover:bg-blue-400 hover:text-black'>
                                                <FaGlobeAfrica />
                                                Virtual Tours
                                            </li>
                                        </Link>
                                        <Link to={'/vr-engagements'}>
                                            <li className='flex flex-row items-center gap-1 text-sm p-1 rounded-md capitalize hover:white hover:bg-blue-400 hover:text-black'>
                                                Virtual Reality Engagements
                                            </li>
                                        </Link>
                                        <div
                                            className='relative group'
                                            tabIndex={0}
                                            onMouseEnter={e => {
                                                e.stopPropagation();
                                                setServicesDropdown(true);
                                            }}
                                            onClick={e => {
                                                e.stopPropagation();
                                                setServicesDropdown(true);
                                            }}
                                        >
                                            <Link to={'/other-services'}>
                                            <li className='p-2 rounded-md capitalize hover:white hover:bg-blue-400 hover:text-white cursor-pointer'>
                                                other services
                                            </li>
                                            </Link>
                                            Mega menu for other services
                                            <div className="absolute left-full top-0 ml-0 w-64 bg-white border-t-4 border-blue-400 shadow-lg rounded-md p-4 z-30 hidden group-hover:block group-focus:block">
                                                <ul className="flex flex-col text-black">
                                                    <Link to={"/other-services"}><li className="capitalize hover:bg-blue-400 cursor-pointer rounded-md p-2">consulting</li></Link>
                                                    <Link to={"/other-services"}><li className="capitalize hover:bg-blue-400 cursor-pointer rounded-md p-2">training</li></Link>
                                                    <Link to={"/other-services"}><li className="capitalize hover:bg-blue-400 cursor-pointer rounded-md p-2">maintenance and support</li></Link>
                                                </ul>
                                            </div>
                                        </div>
                                    </ul>
                                )}
                            </li> */}
                            {/* <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'><Link to={'/case-studies'}>case studies</Link></li> */}
                            {/* <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'><Link to={'/blogs'}>blogs</Link></li> */}
                            {/* <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'><Link to={'/rentals'}>rentals</Link></li> */}
                            {/* <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'><Link to={'/digi-center'}>DigiCenter</Link></li> */}
                            <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400 whitespace-nowrap'><Link to={'/aboutus'}>about us</Link></li>
                            <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400 whitespace-nowrap'><Link to={'/gallery'}>gallery</Link></li>
                            <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400 whitespace-nowrap'><Link to={'/contactus'}>contact us</Link></li>
                        </ul>
                    </div>
                </div>
                <div className='flex-1 flex justify-center'>
                    <ul className='flex flex-row gap-5 items-center'>
                        <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'>
                            <a href='/career'>
                                <button className='capitalize px-6 py-1 border-x border-y font-semibold bg-blue-400 text-black border-blue-400 rounded-md hover:bg-blue-600 hover:border-blue-600 hover:text-white transition-all duration-300'>
                                   Careers
                                </button>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Mobile Menu Overlay - overlaps all content in mobile view */}
            {/* Mobile specific layout for hamburger and title */}
            <div className='flex items-center justify-between w-full md:hidden px-4 h-12 bg-white'>
                <div className='headerTitle'>
                    <a href='/'>
                        <img src="../assets/mainlogotransparentbg.png" alt="querencia Logo" className='h-10 w-24 object-fill pt-0' />
                    </a>
                </div>
                <div className='z-40'>
                    <button onClick={toggleMenu} className='text-2xl focus:outline-none text-black'>
                        {isMenuOpen ? (
                            <HiX className='transition-transform duration-300 transform rotate-90' />
                        ) : (
                            <HiMenuAlt3 className='transition-transform duration-300' />
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay - overlaps all content in mobile view */}
            {isMenuOpen && (
                <div className="fixed inset-0 bg-[#0b001a] bg-opacity-95 z-[60] md:hidden flex flex-col items-center justify-center text-center">
                    <button onClick={toggleMenu} className='absolute top-4 right-4 text-white text-3xl focus:outline-none'>
                        <HiX />
                    </button>
                    <div className='flex flex-col gap-7 text-white text-2xl w-full px-4'>
                        <ul className='flex flex-col gap-3 justify-center text-center text-sm items-center'>
                            <li className='capitalize text-base font-semibold tracking-tight py-2 hover:text-blue-400'><a href={'/'} onClick={toggleMenu}>Home</a></li>
                            {/* <li className='capitalize text-lg font-semibold tracking-tight py-2 hover:text-blue-400'><a href={'/request-quote'} onClick={toggleMenu}>Request Quote</a></li> */}
                            {/* <li className='capitalize text-lg font-semibold tracking-tight py-2 hover:text-blue-400'><a href={'/vr-engagements'} onClick={toggleMenu}>VR engagements</a></li> */}
                            <li className='relative capitalize text-base font-semibold tracking-tight py-2 hover:text-gray-300'>
                                <button onClick={() => setSolutionsDropdown(!solutionsDropdown)} className='flex items-center gap-1 cursor-pointer text-white hover:text-blue-400 focus:outline-none'>
                                    <span className='capitalize text-base'>products</span>
                                    <IoIosArrowDown className={`${solutionsDropdown ? 'rotate-180' : ''} transition-transform duration-200`} />
                                </button>
                                {solutionsDropdown && (
                                    <ul className='flex flex-col gap-2 mt-2 text-sm text-white items-center'>
                                        <li className='p-1 capitalize hover:text-blue-400'><a href='/business-loans' onClick={toggleMenu} className='flex flex-row items-center gap-1 p-1'>Business Loans - Rapid Cash</a></li>
                                        <li className='p-1 capitalize hover:text-blue-400'><a href='/sme-loans' onClick={toggleMenu} className='flex flex-row items-center gap-1 p-1'>SME Loans - Speedy Sika</a></li>
                                        <li className='p-1 capitalize hover:text-blue-400'><a href='/salary-loans' onClick={toggleMenu} className='flex flex-row items-center gap-1 p-1'>Salary Loans - Instant Advance</a></li>
                                    </ul>
                                )}
                            </li>
                            {/* <li className='relative capitalize text-base font-semibold tracking-tight py-2 hover:text-gray-300'>
                                <button onClick={() => setServicesDropdown(!servicesDropdown)} className='flex items-center gap-1 cursor-pointer text-white hover:text-blue-400 focus:outline-none'>
                                    <span className='capitalize text-lg'>services</span>
                                    <IoIosArrowDown className={`${servicesDropdown ? 'rotate-180' : ''} transition-transform duration-200`} />
                                </button>
                                {servicesDropdown && (
                                    <ul className='flex flex-col gap-2 mt-2 text-sm text-white items-center'>
                                        <li className='p-1 capitalize hover:text-blue-400'><Link to={'https://vrifyafrica.onrender.com/virtual-tour'} target='_blank' rel='noopener noreferrer' onClick={toggleMenu} className='flex flex-row items-center gap-1 p-1'><FaGlobeAfrica /> virtual tours</Link></li>
                                        <li className='p-1 capitalize hover:text-blue-400'><Link to={'/vr-engagements'} onClick={toggleMenu} className='flex flex-row items-center gap-1 p-1'><FaVrCardboard /> virtual reality engagements</Link></li>
                                    </ul>
                                )}
                            </li> */}
                            {/* <li className='capitalize text-lg font-semibold tracking-tight py-2 hover:text-blue-400'><Link to={'/case-studies'} onClick={toggleMenu}>case studies</Link></li> */}
                            {/* <li className='capitalize text-lg font-semibold tracking-tight py-2 hover:text-blue-400'><Link to={'/blogs'} onClick={toggleMenu}>blogs</Link></li> */}
                            {/* <li className='capitalize text-lg font-semibold tracking-tight py-2 hover:text-blue-400'><Link to={'/rentals'} onClick={toggleMenu}>rentals</Link></li> */}
                            {/* <li className='capitalize text-lg font-semibold tracking-tight py-2 hover:text-blue-400'><Link to={'/digi-center'} onClick={toggleMenu}>DigiCenter</Link></li> */}
                            <li className='capitalize text-base font-semibold tracking-tight py-2 hover:text-blue-400'><a href={'/aboutus'} onClick={toggleMenu}>about us</a></li>
                            <li className='capitalize text-base font-semibold tracking-tight py-2 hover:text-blue-400'><a href={'/gallery'} onClick={toggleMenu}>gallery</a></li>
                            <li className='capitalize text-base font-semibold tracking-tight py-2 hover:text-blue-400'><a href={'/contactus'} onClick={toggleMenu}>contact us</a></li>
                            <li className='capitalize text-sm font-semibold tracking-tight hover:text-blue-400'>
                                <a href='/career' onClick={toggleMenu}>
                                    <button className='capitalize px-4 py-2 border-x border-y bg-blue-400 text-black border-blue-400 rounded-md hover:bg-blue-600 hover:border-blue-600 hover:text-white transition-all duration-300'>
                                        Careers
                                    </button>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Header;
